import React from "react";
import SubscriptionBanner from "./banner";
import { useSubscription } from "../../context/SubscriptionProvider";
// import { hasPremiumSubscription } from "../../utils/subscription";

const SubscribeTag = () => {
  const [showBanner, setShowBanner] = React.useState(true);
  const { hasSubscription } = useSubscription();
  return (
    <>
      {/* {showBanner && hasPremiumSubscription() && ( */}
      {showBanner && !hasSubscription() && (
        <SubscriptionBanner onClose={() => setShowBanner(false)} />
      )}
    </>
  );
};

export default SubscribeTag;
